<template>
  <div class="d-flex" style="gap: 30px;">
    <ShareNetwork
      v-for="icon in icons" :key="icon"
      :network="icon.network"
      :url="icon.url"
      :title="icon.title"
      :description="icon.description"
      :quote="icon.quote"
    >
      <img alt="" :src="icon.image">
    </ShareNetwork>
  </div>
</template>

<script>
export default {
  props: {
    blog: { type: Object },
    icons: { type: Array }
  }
}
</script>

<style>

</style>